module.exports = __webpack_public_path__ + "static/media/name.ed6ff33b.svg";